module.exports = __webpack_public_path__ + "img/Logo_IC_Setembro_Amarelo_630x400.088a1188.svg";